import { orderBy } from "lodash";
import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import useStyles from "./styles";
import { setFilters, setSearchVal } from "./slaTableFiltersSlice";
import DataTable from "components/DataTable/DataTable";
import useSortOptions from "hooks/useSortOptions";
import FilterService, { fieldTypes } from "services/filterService";
import FormatService from "services/formatService";

const SlaTable = ({
    washSlaData,
}) => {

    const classes = useStyles();
    const [sortOptions, sortData] = useSortOptions();
    const dispatch = useDispatch();
    
    const { searchVal, filters } = useSelector(state => state.slaTableFilters);
    
    let assetsSlaList = washSlaData.filter(a => a.underSlaInLastCycle != null).map(a => ({
        ...a,
        formattedDate: FormatService.formatDate(a.latestCompletedWash),
    })) || [];


    const columns = [
        { name: "VIN", key: "descriptor" },
        { name: "Asset Id", key: "assetId" },
        { name: "Within SLA", key: "underSlaInLastCycle", component: (row) => withinSlaColumn(row.underSlaInLastCycle) },
        { name: "Latest Completed Wash", key: "formattedDate" }
    ];

    const withinSlaColumn = (underSlaInLastCycle) => {
        return <div className={`${classes.withinSlaColumn} ${underSlaInLastCycle ? classes.withinSla : classes.aboveSla}`}>
        {underSlaInLastCycle ?  'Within SLA' : 'Above SLA'
        }
        </div>
    }

    const filterConfig = [
        {
            type: fieldTypes.LIST,
            size: 2,
            title: 'Within SLA',
            key: 'underSlaInLastCycle',
            multiple: true,
            values: [{ name: 'Within SLA', id: true }, { name: 'Above SLA', id: false }],
        }
    ];

    const onDropFilter = (filterValue, prop) => {
        updateFilters(prop, filterValue);
    };

    const updateFilters = (prop, value) => {
        const newFilters = { ...filters, [prop]: { value } }
        dispatch(setFilters(newFilters));
    }
    const searchByText = value => {
        dispatch(setSearchVal(value.trim()));
    }

    const onResetFilters = () => {
        dispatch(setFilters({
            clientId: { value: null },
            lotId: { value: null }
        }));
    }

    let filteredData = FilterService.filter(filters, searchVal, assetsSlaList, filterConfig);

    return (
        <>
            <DataTable
                title="Assets Within SLA This Cycle"
                columns={columns}
                rows={orderBy(
                    filteredData,
                    sortOptions.columnToSort,
                    sortOptions.sortDirection
                )}
                rowIdentifier='id'
                onSort={sortData}
                sortDirection={sortOptions.sortDirection}
                columnToSort={sortOptions.columnToSort}

                onSearch={searchByText}
                searchVal={searchVal}

                dropDownsConfig={filterConfig}
                filters={filters}
                onDropFilter={onDropFilter}
                withFilterPanel={true}
                onResetFilters={onResetFilters}
            />
        </>
    );
};

export default memo(SlaTable);
